import { atom } from "jotai";

export const selectedTierAtom = atom<number>(0);
